import { callGet, callPost } from '../../services/axios'
import { GET_CONTACTS_WITH_SUPPLIER_IDS_FAIL, GET_CONTACTS_WITH_SUPPLIER_IDS_START, GET_CONTACTS_WITH_SUPPLIER_IDS_SUCCESS } from '../actionTypes/vendor'

export const createContact = ({ contactInfo, supplierId = null, listSupplierId = null, isInCalls = null, vendorInCallsDetailsId = null, isContactExist = false, linkToSupplier = false }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/createContact`, {
        contactInfo,
        supplierId,
        listSupplierId,
        isInCalls,
        vendorInCallsDetailsId,
        isContactExist,
        linkToSupplier
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}


export const updateSupplierContact = ({ contactInfo, supplierId = null, listSupplierId = null, isInCalls = null, vendorInCallsDetailsId = null }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/updateSupplierContact`, {
        contactInfo,
        supplierId,
        listSupplierId,
        isInCalls,
        vendorInCallsDetailsId,
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getContactById = ({ contactId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/contact/getContactById`, token, {
        contactId
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getContacts = ({ supplierIds, supType = 'master', listSupplierId = null, vendorInCallDetailsId = null, listSupplierIds = [], isGetForEmailHistory = false }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    if (supType) {
        dispatch({
            type: GET_CONTACTS_WITH_SUPPLIER_IDS_START
        })
    }
    return callPost(`/api/contact/getContacts`, {
        supplierIds,
        listSupplierId,
        vendorInCallDetailsId,
        listSupplierIds,
        isGetForEmailHistory
    }, token).then((res) => {
        if (supType) {
            dispatch({
                type: GET_CONTACTS_WITH_SUPPLIER_IDS_SUCCESS,
                data: res['data']?.contacts,
                supType
            })
        }
        return Promise.resolve(res['data'])
    }).catch(err => {
        if (supType) {
            dispatch({
                type: GET_CONTACTS_WITH_SUPPLIER_IDS_FAIL,
                supType
            })
        }
        return Promise.reject(err)
    })
}

export const getExistingContacts = ({ searchValue, type = '' }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/contact/getExistingContacts`, token, {
        searchValue,
        type
    }).then((res) => {
        const contacts = res?.data?.contacts?.length > 0 ? res?.data?.contacts : []
        const supplierContacts = res?.data?.supplierContacts?.length > 0 ? res?.data?.supplierContacts : []
        const result = {
            contacts: []
        }
        result.supplierContacts = supplierContacts
        if (contacts?.length > 0) {
            const allContacts = contacts?.map(contact => {
                const supplierIds = supplierContacts?.filter(data => data?.contactId === contact?.id)?.map(data => {
                    return data?.supplierId
                })
                contact.supplierIds = supplierIds || []
                return contact
            })
            result.contacts = allContacts || []
        }
        return Promise.resolve(result)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const deleteContact = ({ contactId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/deleteContact`, {
        contactId
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const updateContact = ({ contactId, contactData }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/updateContact`, {
        contactId,
        contactData
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const checkExistingContactWithEmailOrPhone = ({ type, value }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/contact/checkExistingContactWithEmailOrPhone`, token, {
        type,
        value
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getLinkedSuppliersByContactId = ({ contactId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callGet(`/api/contact/getLinkedSuppliersByContactId`, token, {
        contactId
    }).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const checkContactLinkedWithMaster = ({ contactId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/checkContactLinkedWithMaster`, {
        contactId
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getContactsByIds = ({ contactIds }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/getContactsByIds`, {
        contactIds
    }, token).then((res) => {
        return Promise.resolve(res['data'])
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const linkContactToSupplier = ({ contactId, listSupplierId, isInCalls, vendorInCallsDetailsId }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/linkContactToSupplier`, { contactId, listSupplierId, isInCalls, vendorInCallsDetailsId }, token).then((res) => {
        return Promise.resolve(res)
    }).catch(err => {
        return Promise.reject(err)
    })
}